import inRange from 'lodash/inRange';
import reduce from 'lodash/reduce';
import has from 'lodash/has';
import keyBy from 'lodash/keyBy';
import values from 'lodash/values';
import transform from 'lodash/transform';

import { METADATA_TYPES } from '../config';

export function dialogue(tcIn, tcOut, transcripts) {
   const _filterTranscriptFn = t => inRange(t.from, tcIn, tcOut) || inRange(t.to, tcIn, tcOut);
   const dialogue = transcripts.filter(_filterTranscriptFn).map(t => t.text).join(' ');
   return dialogue.replace(/(([\\?\\!\\.])\r\s)/g, '$1\n').split('\r').join('');
}

export function metadata(tcIn, tcOut, metadata, timedata) {
   const _filterMetadataFn = t => tcOut > t.tcIn && tcIn < t.tcOut;
   const cacheOfMetadata = keyBy(metadata, 'id');

   const timedataCache = transform(timedata, (memo, timedata) => {
      const { metadataType, metadataId } = timedata;
      const metadata = cacheOfMetadata[metadataId];
      if (!metadata) {
         // eslint-disable-next-line
         console.error(`Can't find metadata with id ${metadataId}`);
         return;
      }
      const { name, thumbnailUrl } = metadata;
      const timedata4showing = { ...timedata, name, thumbnailUrl };
      (memo[metadataType] = memo[metadataType] || []).push(timedata4showing);
   }, {});

   return reduce( METADATA_TYPES, (memo, { type }) => {
      const all = timedataCache[type];

      const filtered = transform(all, (memo, item) => {
         if ( !has(memo, item.metadataId) && _filterMetadataFn(item) ) {
            memo[item.metadataId] = cacheOfMetadata[item.metadataId];
         }
      }, {});
      return [...memo, ...values(filtered) ];
   }, []);
}
